import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    SettingType,
    CodeBlock,
    BlockType,
    ValidationMessage,
    ValidationMessageType,
    SettingState,
    TibboDataType,
    SettingOption,
} from '@appblocks/codegeneration/types';
import * as tios from './tios';
import * as zephyr from './zephyr';

export default class SocketConnection extends BaseFeature {
    constructor() {
        super();
        this.name = 'Socket Connection';
        this.id = 'socket_connection';
        this.singleInstance = false;

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                default: 'S1',
            },
            {
                id: 'PROTOCOL',
                name: 'Protocol',
                settingType: SettingType.HIDDEN,
                required: true,
                default: 'PL_SOCK_PROTOCOL_TCP',
                options: [
                    {
                        name: 'TCP',
                        value: 'PL_SOCK_PROTOCOL_TCP',
                    },
                    {
                        name: 'UDP',
                        value: 'PL_SOCK_PROTOCOL_UDP',
                    },
                ],
            },
            {
                id: 'ROLE',
                name: 'Client or Server',
                settingType: SettingType.OPTION,
                required: true,
                default: 'client',
                options: [
                    {
                        name: 'Client',
                        value: 'client',
                    },
                    {
                        name: 'Server',
                        value: 'server',
                    },
                ],
            },
            {
                id: 'LISTENPORTS',
                name: 'Listening Port',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '8081',
            },
            {
                id: 'SERVERIP',
                name: 'Server IP',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                default: '1.0.0.1',
            },
            {
                id: 'SERVERPORT',
                name: 'Server Port',
                settingType: SettingType.STRINGVARIABLE,
                required: true,
                max: 65535,
                default: '6480',
            },
            {
                id: 'TXBUF',
                name: 'TX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
            {
                id: 'RXBUF',
                name: 'RX Buffer Pages',
                settingType: SettingType.BUFFER,
                required: true,
                default: '1',
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getState(settingId: string): SettingState {
        if (this.getSettingValue('ROLE') === 'client') {
            switch (settingId) {
                case 'LISTENPORTS':
                case 'INTERFACES':
                    return SettingState.HIDDEN;
                default:
                    return SettingState.ENABLED;
            }
        } else if (this.getSettingValue('ROLE') === 'server') {
            switch (settingId) {
                case 'SERVERIP':
                case 'SERVERPORT':
                case 'TARGET_INTERFACE':
                    return SettingState.HIDDEN;
                default:
                    return SettingState.ENABLED;
            }
        }
        return SettingState.ENABLED;
    }

    getSettingOptions(settingId: string): SettingOption[] | undefined {
        const { project } = this;
        if (settingId === 'TARGET_INTERFACE') {
            return project.getNetworkInterfaces();
        }
        return super.getSettingOptions(settingId);
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'tios':
                return tios.getCodeBlocks(this);
            case 'zephyr':
                return zephyr.getCodeBlocks(this);
            default:
                return [];
        }
    }
}
